import { LRUMap } from 'lru_map';
var AI_SUMMARY_CACHE_SIZE = 100;

// Contains cached mapping between url and an AISummaryService.
export var AISummariesStore = new LRUMap(AI_SUMMARY_CACHE_SIZE);